<template>
  <BaseNode
    :node="node"
    :editor-errors="editorErrors"
    :position="index + 1"
    color="#4472c4"
  >
    <div
      v-if="filterHtml"
      v-html="filterHtml"
      class="ConnectorElementNode_filters"
    ></div>
    <div
      class="ConnectorElementNode_noFilters"
      v-else
    >{{$t('common.No filters')}}</div>
  </BaseNode>
</template>

<script>
import nodeMixin from './nodeMixin'
import {formatFilterToParts} from '../../api/format.ts'

export default {
  mixins: [nodeMixin],
  computed: {
    filterHtml() {
      return this.node.filters
        .map((filter, index) => {
          const parts = formatFilterToParts(filter)
          const html = parts.map(d => {
            return `<span class="FilterPart_${d.type}">${d.value}</span>`
          }).join(' ')
          return `<div class="FilterPart"><span class="FilterPart_prefix">${index ? this.$t('common.and') : this.$t('common.if')}</span> ${html}</div>`
        }).join('')
    }
  }
}
</script>

<style lang="scss">
.ConnectorElementNode_filters {
  font-size: 11px;
}
.ConnectorElementNode_noFilters {
  color: #666;
  font-size: 11px;
  font-style: italic;
}

.FilterPart {
  max-width: 300px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.FilterPart_prefix {
  color: #737373;
}
.FilterPart_label {
  color: #008000;
}
.FilterPart_value {
  color: #800080;
}
</style>
